import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import SalesEnvironmentCustomTooltip from "./salesEnvironmentCustomTooltip";

// 각 파이 섹션에 대한 색상
const EnvironmentChart = ({ dataList }) => {
  const [dataType, setDataType] = useState("device");

  useEffect(() => {
    if (dataList[0]?.payenv) {
      setDataType("device");
    } else if (dataList[0]?.paymethod) {
      setDataType("method");
    }
  }, [dataList]);

  const totalValue = dataList.reduce((acc, cur) => {
    acc += cur.realpay;
    return acc;
  }, 0);

  const getCellColor = (title) => {
    switch (title) {
      case "PC":
        return "#b658ff";
      case "MO":
        return "#46a196";
      case "신용카드":
        return "#cf6679";
      case "카카오페이":
        return "#ffa438";
      case "토스페이":
        return "#1b5ddd";
      case "네이버페이":
        return "#53bd20";
      default:
        return "#f3f3f3";
    }
  };

  return (
    <PieChart width={400} height={400}>
      <Pie
        data={dataList}
        dataKey="realpay"
        nameKey={dataType === "device" ? "payenv" : "paymethod"}
        cx="50%"
        cy="50%"
        outerRadius={119}
        innerRadius={60} // 도넛 형태를 만들기 위해 설정
        label={({ cx, cy, midAngle, innerRadius, outerRadius, realpay }) => {
          const RADIAN = Math.PI / 180;
          const radius = innerRadius + (outerRadius - innerRadius) * 0.5; // 파이 내부에 위치시키기 위한 반경 계산
          const x = cx + radius * Math.cos(-midAngle * RADIAN); // x 좌표 계산
          const y = cy + radius * Math.sin(-midAngle * RADIAN); // y 좌표 계산

          return (
            <text
              x={x}
              y={y}
              fill="#f3f3f3" // 텍스트 색상
              textAnchor="middle"
              dominantBaseline="central" // 텍스트 수직 중앙 정렬
              style={{
                fontFamily: "Pretendard",
                fontWeight: 700,
                fontSize: 13,
                lineHeight: "20px",
                letterSpacing: "-0.3%",
              }}
            >
              <tspan
                textAnchor="middle"
                x={x}
                dy="0"
              >{`${realpay.toLocaleString()}원`}</tspan>
              <tspan textAnchor="middle" x={x} dy="15">{`(${(
                (realpay / totalValue) *
                100
              ).toFixed(1)}%)`}</tspan>
            </text>
          );
        }} // 금액과 비율 표시
        labelLine={false} // 라벨 라인 제거
        stroke="none" // 파이 섹션 테두리 제거
      >
        {dataList.map((item, index) => (
          <Cell
            key={`cell-${item}-${index}`}
            fill={getCellColor(
              dataType === "device" ? item.payenv : item.paymethod
            )}
          />
        ))}
      </Pie>
      <Tooltip
        position={{ x: -100, y: 70 }}
        content={<SalesEnvironmentCustomTooltip dataType={dataType} />}
      />
    </PieChart>
  );
};

export default EnvironmentChart;
